import { Bank, OtherSubjectsForm } from '@ha/domain';
import { maxLength } from '@ha/hypotheken-afspraak.constants';

import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ApContentModule, ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApRadioButtonComponent, ApRadioGroupComponent } from '@ap/radio';
import { ApTextareaComponent } from '@ap/textarea';

@Component({
    selector: 'other-subjects',
    templateUrl: './other-subjects.component.html',
    standalone: true,
    imports: [
        ApAnalyticsModule,
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApTextareaComponent,
        ApRadioButtonComponent,
        ApRadioGroupComponent
    ]
})
export class OtherSubjectsComponent implements OnInit {
    private readonly contentService = inject(ApContentService);
    private readonly destroyRef = inject(DestroyRef);

    protected readonly maxLength = maxLength;
    protected readonly bank = Bank;
    isExistingCustomer: boolean;

    readonly otherSubjectsForm = input.required<FormGroup<OtherSubjectsForm>>();

    ngOnInit() {
        this.subscribeToControls();
    }

    private subscribeToControls(): void {
        const existingCustomer = this.otherSubjectsForm().controls.existingCustomer;
        const bank = this.otherSubjectsForm().controls.bank;

        existingCustomer.valueChanges
            .pipe(
                filter((value) => value !== null),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((value: any) => {
                this.isExistingCustomer = Boolean(JSON.parse(value));

                if (this.isExistingCustomer) {
                    bank.setValidators(Validators.required);
                } else if (!this.isExistingCustomer) {
                    bank?.clearValidators();
                    bank?.reset();
                }
                bank?.updateValueAndValidity();
            });
    }

    getErrorMessage(contentKey: string): ErrorMessages {
        const label: string = this.contentService.get(contentKey).toLowerCase();
        return {
            maxlength: this.contentService.get('general.error.max', {
                fieldName: label,
                number: maxLength.otherSubjects.toString()
            }),
            incorrect: this.contentService.get('general.error.incorrect', {
                fieldName: label
            })
        } as ErrorMessages;
    }
}
